
import { View } from 'backbone';

import nameTemplate from 'properties/main/assetPreview.ejs';
import restService from 'RestService.js';
import $ from 'jquery';


class MainAssetPreviewView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.listenTo(this.model, 'change', this.render);
        return this;
    }


    render() {
        this.$el.empty();

        this.createPreview();

        this.delegateEvents();
        return this;
    }

    getPreviewElement(){
        return $('#asset_preview');
    }

    createPreview(){
        var isImage = new RegExp('image/');

        if(isImage.test(this.model.get('mimeType'))){
            //Currently only images can create a preview
            if(this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }

            let urlResult=restService.getAssetURL(this.model.get('assetId'));

            var imageTag = $('<img />').attr({
                'src':urlResult ,
                'style': 'max-width:100%;max-height:100%; '
            });
            
            let maxHeight = $('.right-rail-content').height() * 0.50; 
            let assetPreview = $('#asset_preview');
            
            $(imageTag).on('load', function() {
                let children = assetPreview.children();
                if (children.length) {
                     children.remove();
                }

                assetPreview.height(maxHeight).append(imageTag);
            });
        }
    }
}

export default MainAssetPreviewView;
